import { http } from "../utils/http";

/** Recruiting autopilot (backend /v1/autopilot). [Claude] 2026-11-02 */
export const getAutopilotOverview = () => http.get("/autopilot/overview");
export const getInterviews = (dateFrom, dateTo) => {
    const params = new URLSearchParams();
    if (dateFrom) params.set("date_from", dateFrom);
    if (dateTo) params.set("date_to", dateTo);
    const qs = params.toString();
    return http.get("/autopilot/interviews" + (qs ? "?" + qs : ""));
};
export const setInterviewStatus = (id, status) => http.post("/autopilot/interviews/" + id + "/status", { status });
export const getQuestions = (status = "open") => http.get("/autopilot/questions?status=" + encodeURIComponent(status));
export const answerQuestion = (id, payload) => http.post("/autopilot/questions/" + id + "/answer", payload);
export const dismissQuestion = (id) => http.post("/autopilot/questions/" + id + "/dismiss", {});
export const getKnowledge = () => http.get("/autopilot/knowledge");
export const createKnowledge = (payload) => http.post("/autopilot/knowledge", payload);
export const updateKnowledge = (id, payload) => http.put("/autopilot/knowledge/" + id, payload);
export const deleteKnowledge = (id) => http.delete("/autopilot/knowledge/" + id);
export const getReview = () => http.get("/autopilot/review");
export const reviewInvite = (id) => http.post("/autopilot/review/" + id + "/invite", {});
export const reviewReject = (id) => http.post("/autopilot/review/" + id + "/reject", {});
export const getComplianceSettings = () => http.get("/compliance/settings");
export const saveAutopilotSettings = (value, comment) =>
    http.put("/compliance/settings/autopilot", { value, comment });
